import { render, staticRenderFns } from "./TableItemIsEnabled.vue?vue&type=template&id=8d44bbfe"
import script from "./TableItemIsEnabled.vue?vue&type=script&lang=ts"
export * from "./TableItemIsEnabled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports